import type { TranslationTree } from '../../types';

export const home: TranslationTree = {
  home: {
    dashboard: {
      welcome: 'Willkommen zurück',
      description:
        'Überwachen, analysieren und prognostizieren Sie die Werkzeugleistung in Ihren aktiven Modulen.',
      scannerTitle: 'Rückverfolgbarkeit',
      scannerDescription: 'Scannen und verfolgen Sie Ihre Fräswerkzeuge',
      analyticsTitle: 'Analytik',
      analyticsDescription: 'Leistung und Trends visualisieren',
      mlTitle: 'Machine Learning',
      mlDescription: 'Werkzeugverschleiß und Restlebensdauer vorhersagen',
      toolViewTitle: 'Werkzeugansicht',
      toolViewDescription: 'Alle registrierten Werkzeuge durchsuchen und prüfen.',
      workshopTitle: 'Werkstatt',
      workshopDescription: 'Werkzeugvorgänge und Bearbeitungssitzungen erfassen.',
      labelizeTitle: 'Beschriftung',
      labelizeDescription:
        'Werkzeugzustand-Bilder klassifizieren, um das Predictive-Maintenance-Modell zu trainieren.',
      toolRecommenderTitle: 'Werkzeug-Ökodesign',
      toolRecommenderDescription:
        'Optimale Schneidwerkzeuge mit KI-gestützten Empfehlungen per genetischem Algorithmus finden.',
    },
  },
};
